<template>
  <Modal title="赠送礼品" v-model="visible" width="640" @on-visible-change="onVisible">
    <Form :label-width="80">
      <Form-item label="礼品">
        <Input v-model="giftName" placeholder="请输入礼品名称"></Input>
      </Form-item>
    </Form>
    <div style="margin-bottom:12px">
      <Button type="primary" :loading="saving" @click="save">保存</Button>
    </div>
    <table class="track-list">
      <thead>
        <tr>
          <th>赠送时间</th>
          <th>礼品</th>
          <th>操作人</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in records" :key="item.id">
          <td>{{ formatTime(item.gmtCreate) }}</td>
          <td>{{ item.giftName }}</td>
          <td>{{ item.creatorName }}</td>
        </tr>
        <tr v-if="!records.length">
          <td colspan="3" style="text-align:center;color:#999">暂无赠送记录</td>
        </tr>
      </tbody>
    </table>
    <div slot="footer">
      <Button type="text" @click="visible=false">关闭</Button>
    </div>
  </Modal>
</template>
<script>
export default {
  name: 'OrderGiftModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      visible: this.value,
      giftName: '',
      saving: false,
      records: []
    }
  },
  watch: {
    value (val) {
      this.visible = val
    },
    visible (val) {
      this.$emit('input', val)
      if (!val) {
        this.$emit('on-close')
      }
    },
    orderId () {
      if (this.visible) {
        this.loadList()
      }
    }
  },
  methods: {
    onVisible (val) {
      if (val) {
        this.giftName = ''
        this.loadList()
      }
    },
    loadList () {
      let self = this
      if (!self.orderId) {
        self.records = []
        return
      }
      self.$http.get('/fundPackage/gift/list', {params: {orderId: self.orderId}}).then(function (res) {
        self.records = res.data || []
      })
    },
    save () {
      let self = this
      let name = (self.giftName || '').trim()
      if (!name) {
        self.$Message.warning('请输入礼品名称')
        return
      }
      if (!self.orderId) {
        self.$Message.warning('订单编号不能为空')
        return
      }
      self.saving = true
      self.$http.post('/fundPackage/gift/insert', {orderId: self.orderId, giftName: name}).then(function (res) {
        if (res && (res.status === 'ok' || res.data > 0)) {
          self.$Message.success('保存成功')
          self.giftName = ''
          self.loadList()
        }
        self.saving = false
      }).catch(function () {
        self.saving = false
      })
    },
    formatTime (v) {
      if (!v) {
        return ''
      }
      if (typeof v === 'string') {
        return v.replace('T', ' ')
      }
      if (Object.prototype.toString.call(v) === '[object Array]' && v.length >= 3) {
        let p = function (n) {
          return n < 10 ? '0' + n : '' + n
        }
        return v[0] + '-' + p(v[1]) + '-' + p(v[2]) + ' ' + p(v[3] || 0) + ':' + p(v[4] || 0)
      }
      return v
    }
  }
}
</script>
<style scoped>
.track-list {
  width: 100%;
  border-collapse: collapse;
}
.track-list th,
.track-list td {
  border: 1px solid #e0e0e0;
  padding: 6px 8px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// OrderGiftModal.vue?f4782d94